module.exports = __webpack_public_path__ + "img/developed.70437949.svg";